<template>
    <div class="page container" data-page="listings">
        <div class="pure-g">

            <div class="pure-u-1">
                <div class="image topImage" style="background-image:url(https://images.prismic.io/vanmglcom/79d41dd1-95e4-416f-82df-b0ec7d572bc2_229275100273561.5f0567265686b.jpg?auto=compress,format);">
                    <div>
                        <h1 class="title">Listings</h1>
                        <p>Your community marketplace. <br>Jobs, Buy &amp; Sell or Find a roommate.</p>
                    </div>
                </div>
            </div>

            <div class="pure-u-1 pure-u-lg-5-24 leftArea">

                <div class="actionBtns">
                    <p class="om-label">Actions</p>
                    <a href="#0" @click.prevent="createNewListing" class="btn green icon-left">
                        <ion-icon name="add-outline"></ion-icon>
                        Add New Listing
                    </a>
                    <Modal
                        ref="modal"
                        title="Create New Ad"
                        type="createNewAd"
                        @refresh="getAllListings"
                    ></Modal>
                </div>

                <div class="filters">
                    <p class="om-label">Filters</p>
                    <nav>
                        <a href="#0" @click.prevent="filter_toggle('all')" class="item" :class="{active: filterItem === 'all'}">All</a>
                        <a 
                            v-for="filter in filters"
                            :key="filter.id"
                            href="#0"
                            @click.prevent="filter_toggle(filter.id)"
                            class="item"
                            :class="{active: filterItem === filter.id}"
                        >
                            {{ filter.title }}
                        </a>
                    </nav>
                </div>
                
            </div>
            
            <div class="pure-u-1 pure-u-lg-14-24 centerArea">

                <div v-if="loading">
                    <div class="loading"></div>
                </div>
                <div v-else>
                    <div v-if="ads.length === 0" class="empty">
                        <p>No listing here yet...</p>
                    </div>
                    <div v-else class="ads">
                        <div v-if="showListings">

                            <div :id="ad.id" v-for="ad in ads" :key="ad.id" class="ad">
                                <div class="ad_header">
                                    <div class="ad_block">
                                        <div class="avatar medium" :style="{backgroundImage: 'url('+ ad.authorImage +')'}">
                                            <template v-if="typeof($store.state.usersOnline[ad.authorId]) !== 'undefined'">
                                                <div 
                                                    class="status"
                                                    :class="{
                                                        online: $store.state.usersOnline[ad.authorId].status === 'online',
                                                        idle: checkLastOnlineTime($store.state.usersOnline[ad.authorId]) !== null,
                                                        offline: $store.state.usersOnline[ad.authorId].status === 'offline',
                                                        'hint hint--top': $store.state.usersOnline[ad.authorId].status === 'offline'
                                                    }"
                                                    :data-hint="checkLastOnlineTime($store.state.usersOnline[ad.authorId], 'offline')"
                                                >
                                                    <span v-if="checkLastOnlineTime($store.state.usersOnline[ad.authorId]) !== null" class="min">
                                                        {{ checkLastOnlineTime($store.state.usersOnline[ad.authorId]) }}
                                                    </span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="ad_block">
                                        <h4 class="adTitle">{{ ad.title }} <span v-if="ad.price !== null" class="adPrice">({{ ad.price }})</span></h4>
                                        <p class="adInfo">
                                            <span class="adAuthorName">{{ ad.authorName }}</span>
                                            <span class="badge adCategory">{{ ad.category | removeSpace }}</span>
                                            <span class="adDate">{{ ad.timestamp.toDate() | moment('MMM DD, h:mm a') }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="ad_center" :style="gradients[ad.background]" :class="'background_'+ ad.background">
                                    <div>
                                        <p class="adContent">{{ ad.content }}</p>
                                    </div>
                                </div>
                                <div class="ad_footer">
                                    
                                    <div v-if="showActionBtns(ad.authorId)" class="actionBtns">
                                        <a href="#0" class="delete" @click.prevent="removeListing(ad.id)">
                                            <ion-icon name="trash"></ion-icon>
                                        </a>
                                    </div>

                                    <Comments
                                        :isSmall="true"
                                        type="ads"
                                        collectionId="ads"
                                        :docId="ad.id"
                                        :key="ad.id"
                                        >
                                    </Comments>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="pure-u-1 pure-u-lg-5-24 rightArea">
                <Banner></Banner>
            </div>
            
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Banner from '@/components/Banner'
    import Modal from '@/components/Modal'
    import Comments from '@/components/Comments'

    export default {
        metaInfo: {
            title: 'Listings',
            meta: [
                {
					property: 'og:title',
                    content: 'Listings',
                    template: '%s | OneMgl Community',
                },
                {
					property: 'twitter:title',
					content: 'Listings',
					template: '%s | OneMgl Community'
				}
            ]
        },

        data(){
            return{
                ads: [],
                loading: true,
                filters: [
                    {
                        title: 'Jobs',
                        id: 'jobs',
                        count: 0
                    },
                    {
                        title: 'Buy & Sell',
                        id: 'buy_sell',
                        count: 0
                    },
                    {
                        title: 'Home & Garden',
                        id: 'home_garden',
                        count: 0
                    },
                    {
                        title: 'Clothing & Accessories',
                        id: 'clothing_accessories',
                        count: 0
                    },
                    {
                        title: 'Electronics',
                        id: 'Electronics',
                        count: 0
                    },
                    {
                        title: 'Family',
                        id: 'family',
                        count: 0
                    },
                    {
                        title: 'Classifieds',
                        id: 'classifieds',
                        count: 0
                    },
                    {
                        title: 'Hobbies',
                        id: 'hobbies',
                        count: 0
                    },
                    {
                        title: 'Entertainment',
                        id: 'entertainment',
                        count: 0
                    },
                    {
                        title: 'Home Sales',
                        id: 'home_sales',
                        count: 0
                    },
                    {
                        title: 'Vehicle Sales',
                        id: 'vehicle_sales',
                        count: 0
                    },
                    {
                        title: 'Other',
                        id: 'other',
                        count: 0
                    }
                ],
                filterItem: 'all',
                showListings: false,
                comments: null,
                commentTextArea: '',
                commentsError: null,
                gradients: [
                    'background-color: #FFE53B;background-image: linear-gradient(147deg, #FFE53B 0%, #FF2525 74%);',
                    'background-color: #08AEEA;background-image: linear-gradient(0deg, #08AEEA 0%, #2AF598 100%);',
                    'background-color: #FAACA8;background-image: linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%);',
                    'background-color: #FF9A8B;background-image: linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%);',
                    'background-color: #4158D0;background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);',
                    'background-color: #0cbaba;background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);'
                ]
            }
        },
        
        components: {
            Banner,
            Modal,
            Comments
        },

        mounted(){
            this.getAllListings()

            if(this.$route.query.action === 'create'){
                this.createNewListing()
                window.history.pushState('listings', 'Listings', '/listings')
            }
        },

        methods: {
            filter_toggle(item){
                this.filterItem = item
                this.loading = true
                this.showListings = false
                this.getAllListings()
            },
            createNewListing(){
                if(this.$store.state.currentUser === null){
                    alert('You need to login first')
                    this.$router.push('/login')
                }else{
                    this.$refs.modal.toggleModal()
                }
            },
            getAllListings(){

                let self = this
                let adsRef = fb.adsCollection.orderBy('timestamp', 'desc')

                adsRef.get().then(snap => {
                    if(snap){

                        let allAds = []

                        snap.forEach(function(doc){
                            let ad = {}
                            ad = doc.data()
                            ad.id = doc.id
                            if(self.filterItem !== 'all'){
                                if(self.filterItem === ad.category){
                                    allAds.push(ad)
                                }
                            }else{
                                allAds.push(ad)
                            }
                        })

                        self.ads = allAds
                        allAds = []

                        self.loading = false
                        self.showListings = true

                        this.scrollToCheck()
                    
                    }else{
                        console.log('No ads found!')

                        self.loading = false
                        self.showListings = false
                    }
                }).catch(err => {
                    console.log('Error getting all ads: ', err)

                    self.loading = false
                    self.showListings = false
                })
            },
            removeListing(id){

                if(confirm('Are you sure you want to remove this listing?')){
                
                    let self = this
                    let adRef = fb.adsCollection.doc(id)

                    self.loading = true
                    self.showListings = false

                    adRef.delete().then(function(){
                        alert('Successfully removed listing!')
                        self.getAllListings()
                    })
                    .catch(err => {
                        console.log('Error deleting listing: ', err)
                        self.loading = false
                    })
                }
            },
            showActionBtns(id){

                let show = false
                
                if(this.$store.state.currentUser !== null){
                    if(this.$store.state.currentUser.uid === id){
                        show = true
                    }
                    if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                        show = true
                    }
                }

                return show
            },
            scrollToCheck(){
                if(this.$route.query.item){
                    setTimeout(() => {
                        let elItem = document.getElementById(this.$route.query.item)
                        if(elItem !== null){
                            this.$scrollTo(elItem, 700, {
                                offset: -60
                            })
                        }
                    }, 1500)
                }
            },
            checkLastOnlineTime(user, offline){
                if(user.status === 'online') return null
                
                let today = moment()
                let lastOnline = moment(user.timestamp)
                let min = today.diff(lastOnline, 'minutes')

                if(offline === 'offline'){
                    return lastOnline.format('MMM D, YYYY - h:mm a')
                }

                if(min < 60){
                    return min + 'm'
                }

                return null
            }
        },
        filters: {
            removeSpace(value){
                if(!value) return
                return value.replace('_',' ') 
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Listings.vue